module.exports = __webpack_public_path__ + "Enterprise_Customer_White_Icon.cd97a6346250bd617104.png";